import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import map from "../img/map.png"
import { useEffect } from 'react'

export default function Header(){

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

    return (
        <header >
            <div className="text-box">
                    <h1 id="title">Outai Tranding</h1>
                    <p id="titleSmall">Negozio Cinese in Centro Verona</p>
            </div>
            <main>
                    <a href="https://www.google.it/maps/place/Outai+Tranding/@45.4381248,10.9870956,17z/data=!3m1!4b1!4m6!3m5!1s0x477f5f21abfef1b5:0xc284532a7f25da9d!8m2!3d45.4381248!4d10.9887643!16s%2Fg%2F11nnm0dzxn?entry=ttu" target='_blank' rel="noreferrer" > <img src={map} alt='Outai Tranding, Via Daniele Manin ' className='map'/></a>
                    <a href="https://www.google.it/maps/place/Outai+Tranding/@45.4381248,10.9870956,17z/data=!3m1!4b1!4m6!3m5!1s0x477f5f21abfef1b5:0xc284532a7f25da9d!8m2!3d45.4381248!4d10.9887643!16s%2Fg%2F11nnm0dzxn?entry=ttu" className="hero-btn" rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faArrowRight} className='sameLine' /> Via Daniele Manin 10A</a>
            </main>
        </header>
    )
}